const CDN = "https://customer-assets-m6fa6gv7.emergentagent.net/job_2580223e-f860-4cfe-b60d-66e085e038dc/artifacts";

export const IMAGES = {
  logo: `${CDN}/zb0jrz2b_IMG_0820.jpeg`,
  chevy: `${CDN}/evrbql7u_IMG_6451.webp`,
  gmc: `${CDN}/tq56vtt3_IMG_6452.webp`,
  ford: `${CDN}/yf0kxt1h_IMG_5181.webp`,
  engine: `${CDN}/94thekyb_IMG_6384.webp`,
};

const CDN2 = "https://customer-assets-wrfwihn1.emergentagent.net/job_diesel-pro-garage/artifacts";

export const NEW_IMAGES = {
  blueF250: `${CDN2}/fczl7vpp_IMG_6454.webp`,
  blackFordRed: `${CDN2}/qvz1aak1_IMG_6455.webp`,
  gmcLimeSide: `${CDN2}/i6wp2bpj_IMG_1597.webp`,
  gmcLimeRear: `${CDN2}/qorog94r_IMG_1599.webp`,
  f350Shop: `${CDN2}/lp30qzeg_IMG_1600.webp`,
  tremor: `${CDN2}/df3l27gl_IMG_1603.webp`,
  nightWheels: `${CDN2}/ypedx52a_IMG_1515.webp`,
  jeepTailgate: `${CDN2}/rgfj8qoi_IMG_1447.png`,
  jeepRear: `${CDN2}/wullhaz6_IMG_5792.png`,
  paintBadges: `${CDN2}/h6on60to_IMG_0825.jpeg`,
  paintHandle: `${CDN2}/v81vanwh_IMG_0824.jpeg`,
  paintMirror: `${CDN2}/g1065vlr_IMG_0823.jpeg`,
  paintRack: `${CDN2}/35roof1h_IMG_0822.jpeg`,
  paintBooth: `${CDN2}/jooaywx4_IMG_0821.jpeg`,
  coastalChevy: `${CDN2}/825v3zl5_IMG_8142.webp`,
  denaliPurple: `${CDN2}/6pqneuco_IMG_6732.jpeg`,
  purpleKit: `${CDN2}/1i0r2uyq_IMG_6735.jpeg`,
  denaliSide: `${CDN2}/qyklz4u1_IMG_6736.jpeg`,
  flyer: `${CDN2}/feefcf8165a30e16_IMG_2762.JPEG`,
};

export const PHONE = "865-258-9267";
export const PHONE_HREF = "tel:+18652589267";
export const EMAIL = "grantcountiss23@gmail.com";

export const SOCIALS = [
  { id: "tiktok", label: "TikTok", handle: "@grant_countiss", url: "https://www.tiktok.com/@grant_countiss" },
  { id: "instagram", label: "Instagram", handle: "@eastern.tn.customz.llc", url: "https://www.instagram.com/eastern.tn.customz.llc" },
  { id: "facebook", label: "Facebook", handle: "Eastern TN Customz", url: "https://www.facebook.com/share/18EB6YyvXi/" },
];

export const SERVICES = [
  {
    id: "diesel",
    title: "Diesel Repair & Performance",
    desc: "Heavy-duty diagnostics, engine bay overhauls, turbo upgrades, tuning and mechanical service for Powerstroke, Duramax and Cummins.",
    image: IMAGES.engine,
  },
  {
    id: "lifts",
    title: "Suspension Lifts & Leveling",
    desc: "Custom lift kits, leveling systems, reservoir shocks and high-clearance setups engineered for stance, command and ride quality.",
    image: NEW_IMAGES.purpleKit,
  },
  {
    id: "lighting",
    title: "Underglow & Wheel Lights",
    desc: "RGBW underglow systems, high-intensity wheel ring lights, accent strips and headlight builds engineered for night dominance.",
    image: IMAGES.gmc,
  },
  {
    id: "wheels",
    title: "Wheels & Off-Road Tires",
    desc: "Deep-lip wheels, mud-terrain and all-terrain tires, mounting, balancing and fitment dialed to your build.",
    image: IMAGES.ford,
  },
  {
    id: "body",
    title: "Paint Match / Body Work",
    desc: "Paint matching, body work, custom bumpers, grille guards, trim and badges — color-matched and finished in-house.",
    image: NEW_IMAGES.coastalChevy,
    caption: "Got this Coastal Dune Chevy 1500 in for paint match on the front end and the mirrors — love the way this color looks. Get with us for pricing and availability on all of your paint matching needs.",
  },
];
